import { type Cluster, MarkerClusterer, Renderer } from '@googlemaps/markerclusterer'
import AdvancedMarkerElement = google.maps.marker.AdvancedMarkerElement

const MAX_INITIAL_ZOOM = 15 // Set a reasonable zoom threshold

export const createClusterer = (map: google.maps.Map) => {
  if (!map) return
  const renderer: Renderer = {
    render: ({ count, position, markers }, stats: any, map: google.maps.Map) => {
      // change color if this cluster has more markers than the mean cluster
      const color = count > Math.max(10, stats.clusters.markers.mean) ? '#ff0000' : '#0000ff'
      // create svg literal with fill color
      const svg = `<svg fill='${color}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 240' width='50' height='50'>
<circle cx='120' cy='120' opacity='.6' r='70' />
<circle cx='120' cy='120' opacity='.3' r='90' />
<circle cx='120' cy='120' opacity='.2' r='110' />
<text x='50%' y='50%' style='fill:#fff' text-anchor='middle' font-size='50' dominant-baseline='middle' font-family='roboto,arial,sans-serif'>${count}</text>
</svg>`
      let title = ''
      if (markers) {
        for (let i = 0; i < markers.length; i++) {
          const marker = markers[i] as AdvancedMarkerElement
          title += marker.element.dataset.name + '\n'
        }
      }
      // adjust zIndex to be above other markers
      const zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count
      // create cluster SVG element
      const parser = new DOMParser()
      const svgEl = parser.parseFromString(svg, 'image/svg+xml').documentElement
      svgEl.setAttribute('transform', 'translate(0 25)')
      const clusterOptions = {
        map,
        position,
        zIndex,
        title,
        content: svgEl
      }
      return new google.maps.marker.AdvancedMarkerElement(clusterOptions)
    }
  }

  return new MarkerClusterer({
    map,
    onClusterClick: (event: google.maps.MapMouseEvent, cluster: Cluster, map: google.maps.Map) => {
      const clusterBounds = cluster.bounds || new google.maps.LatLngBounds()
      const currentZoom = map.getZoom() || 20
      if (currentZoom < MAX_INITIAL_ZOOM) {
        // If not at max desired zoom, zoom in but limit it
        map.fitBounds(clusterBounds, 200)
        if ((map.getZoom() || 20) > MAX_INITIAL_ZOOM) {
          map.setZoom(MAX_INITIAL_ZOOM)
        }
      } else {
        // If already at desired zoom, let the user click the cluster again for further zooming
        map.fitBounds(clusterBounds, 200)
      }
    },
    renderer
  })
}
